import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getData, postData } from '../../Service/ApiMethod'
import { Jobseeker_TimeSheet, RECURITER_TIMESHEET, TIMESHEET_DOWNLOAD } from '../../Service/service'
import BackBar from '../home/BackBar'
import HireBoxBlackScreen from './HireBoxBlackScreen'
import 'jspdf-autotable';
import jsPDF from 'jspdf'
import { Progress } from 'reactstrap'
import Swal from "sweetalert2";
// import { t } from 'i18next'
import { useTranslation } from 'react-i18next'
import { lang } from '../../lang'


function HireWithTimeSheet() {
  const [ln,setLn] = useState('en')
  const [timeSheet, setTimeSheet] = useState()
  const [showTimeSlot, setShowTimeSlot] = useState(false)
  const [timeSlotIndexing, setTimeSlotIndexing] = useState()
  const [blackScreenPopup, setBlackScreenPopup] = useState(false)
  const [greenPopup, setGreenPopup] = useState(false)
  const [redPopup, setRedPopup] = useState(false)
  const [timesheetid, setTimesheetId] = useState()
  const [status, setStatus] = useState()



  const {t} = useTranslation();
  const location = useLocation()

  const HiredCandidateData = location?.state?.item
  console.log('HiredCandidateData', HiredCandidateData)

  // const getTimesheet = () => {

  //    getData(Jobseeker_TimeSheet)
  //    .then(res => {
  //         if (res.status_code === 200) {
  //           // setTimesheet(res?.data)
  //           let finalObj = {};
  //           res?.data.forEach(item => {
  //             if (finalObj[item?.date]) {
  //               finalObj[item?.date].push(item);
  //             } else {
  //               finalObj[item?.date] = [item];
  //             }
  //           });
  //           let tmp = [];
  //           Object.keys(finalObj).map(v => {
  //             tmp.push({
  //               date: v,
  //               data: [...finalObj[v]],
  //             });
  //             // console.log('*** date with data ***', JSON.stringify(tmp));
  //             setTimesheet([...tmp]);
  //           });
  //         } else {
  //           console.log(res.error_message);
  //         }
  //       })
  //       .catch(error => { });
  //   };


  const handleReject = () => {

  }

  const download = (id) => {
    getData(TIMESHEET_DOWNLOAD + id)
      .then((response) => response.json())
      .then((data) => {

        const marginLeft = 180;
        const unit = "px";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"
        const doc = new jsPDF(orientation, unit, size);
        const title = "Time sheet";
        const columns = ['Date', 'Check In', 'Check Out', 'Total Hours', 'Task Details', 'Status'];
        const rows = data?.data && data?.data?.map(user => {
          return (
            [user?.date, user?.check_in_time, user?.check_out_time, user?.hours_worked, user?.task_details, user?.status]
          )
        });

        let content = {
          startY: 50,
          head: [columns],
          body: rows
        };
        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        // doc?.autoTable({
        //   head: [columns],
        //   body: rows
        // });



        // doc.text(JSON.stringify(data?.data ), 10, 10);
        // doc.autoTable({ html: '#api-data' });

        // Save the PDF file
        doc.save('CatZapp.pdf');
        if (data?.data) {
          alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Time sheet downloaded successfully, Please check your download folder"]:"")
        } else { }
      })

      .catch((error) => {
        console.log("Error in categories from Post Form", error);
      });
  };





  const getTimeSheetData = () => {
    getData(Jobseeker_TimeSheet + HiredCandidateData?.timesheet_id)
      .then(response => response.json())
      .then(res => {
        console.log('TimeSheet Data', res)
        // setTimeSheet(data.data)

        if (res?.status_code === 200) {
          setTimeSheet(res?.data)
          let finalObj = {};
          res?.data?.forEach(item => {
            if (finalObj[item?.date]) {
              finalObj[item?.date].push(item);
            } else {
              finalObj[item?.date] = [item];
            }
          });
          let tmp = [];
          Object.keys(finalObj).map(v => {
            tmp.push({
              date: v,
              data: [...finalObj[v]],
            });
            // console.log('*** date with data ***', JSON.stringify(tmp));
            setTimeSheet([...tmp]);
          });
        } else {
          console.log(res.error_message);
        }
      })
  }

  console.log('timesheet', timeSheet)


  let objs = {
    timesheet_id: timesheetid,
    status: status
  }
  console.log(objs, "objsobjs")


  const ApproveTimesheet = () => {
    postData(objs, RECURITER_TIMESHEET)
      .then(response => response.json())
      .then(res => {
        console.log('TimeSheet Data', res)
        setTimeout(()=>{
          window.location.reload()
        },2000)
      })

  }

  useEffect(() => {
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
    getTimeSheetData()
  }, [])

  function Approved() {
    Swal.fire("Approved Successfully");
  }
    function DisApproved() {
      Swal.fire("DisApproved Successfully");
    }

  return (
    <div>
      <BackBar title={t("Hire")} />
      {/* -----------------------------Hire Candidate profile card--------------------- */}
      <div className='timesheet-col'>
      <div className="recommended-profile pb-2 " onClick={(e) => {
        e.stopPropagation()
        //   props?.timesheetPopup(true)
      }}>
        <div className="row">
          <div className=" col-md-1 col-sm-12 px-0 relative flex-center">
            {/* {HiredCandidateData?.seeker_details[0]?.is_premium &&
                      <div style={{position:'absolute', top:'-5%', left:'5%'}}>
                      <img 
                      src="./images/premium-tag.png"
                      className="premium-tag"
                      // title="Call"
                      alt=""
                    />
                      </div>
                      }  */}
                      <div className='candidate-profile'>
                      <img style={{  }} src={HiredCandidateData?.seeker_details[0]?.image} alt="" className="" />
                      </div>
        
            {/* <div className="view-profile cndiate horizontal-center mb-2"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation()
                setBlackScreenPopup(true)

              }}>
              <span className="view-profile-link " >{t('View Full Profile')}</span>
            </div> */}
          </div>
          <div className=" col-md-11 col-sm-12 pr-0 mt-1 flex-column d-flex justify-content-center">
            <h2
              className="card-heding relative"
            // onChange={(e) => setHireList(e.target.value)}
            >
              {HiredCandidateData?.seeker_details[0]?.first_name} {HiredCandidateData?.seeker_details[0]?.last_name}
              <img
                src="./images/profile-download.png"
                style={{ height: "unset", width: "unset" }}
                alt=""
                className="addprofile"
                onClick={(e) => {
                  e.stopPropagation();
                  download(HiredCandidateData?.timesheet_id);
                  // setClientDetail(true)

                }}
              // onChange={(e) => setHireList(e.target.value)}
              />
            </h2>
            <p
              className="hired-designation"
            // onChange={(e) => setHireList(e.target.value)}
            >
              {HiredCandidateData?.seeker_details[0]?.profile_title}
            </p>
            <div className="row mt-1">
              <div className="col-6 px-0">
                <p
                  className="card-subHeading"
                // onChange={(e) => setHireList(e.target.value)}
                >
                  {t('Hired Date')}
                </p>
              </div>
              <div className="col-6 px-0">
                <p
                  className="profile-info"
                // onChange={(e) => setHireList(e.target.value)}
                >
                  {moment(HiredCandidateData?.hire_date, 'DD-MM-YYYY')?.format('DD MMM YYYY')}
                  {/* {moment(HiredCandidateData?.hire_date).format('YYYY MMMM Do')} */}

                </p>
              </div>
              <div className="col-6 px-0">
                <p
                  className="card-subHeading"
                // onChange={(e) => setHireList(e.target.value)}
                >
                  {t('Job Duration')}
                </p>
              </div>
              <div className="col-6 px-0">
                <p
                  className="profile-info"
                // onChange={(e) => setHireList(e.target.value)}
                >
                  {moment(HiredCandidateData?.from_date)?.format('D MMM YYYY')} - {moment(HiredCandidateData?.to_date)?.format('D MMM YYYY')}
                </p>
              </div>
              <div className="col-6 px-0">
                <p
                  className="card-subHeading"
                // onChange={(e) => setHireList(e.target.value)}
                >
                  {t('Hours Worked')}
                </p>
              </div>
              <div className="col-6 px-0">
                <p
                  className="profile-info"
                // onChange={(e) => setHireList(e.target.value)}
                >
                  {" "}
                  {HiredCandidateData?.hours_worked} {lang && Object.keys(lang).length > 0 ? lang[ln]?.HireDetails["Hours"]:""}{" "}
                </p>
              </div>
            </div>
            {/* <hr className="blue-line-bottom" />
              <hr className="blue-line" /> */}
            {/* <meter min={0} max={100} value={HiredCandidateData?.seeker_details[0]?.percentage_match} /> */}
            <Progress height='5px' ClassName='progress ' value={parseInt(HiredCandidateData?.percentage_match)} />

            <div className='' style={{ display: 'flex', justifyContent: 'end', marginTop: '10px' }}>
              <img src='./images/vaccancy.png' style={{ height: "20px", marginRight: "2px" }} /> {t('OnGoing Job')}
            </div>
          </div>
        </div>
      </div>
      </div>
      {/* -----------------------------Hire Candidate profile card--------------------- */}

      {/* ------------------------------------ TimeSheet ------------------------------- */}

      <p className="my-2 popup-heading p-2">{t('Time Sheet')}</p>

      <>
        {/* <div className="text-center bg-white sticky-top p-3" > */}
        {/* <div >
            <p className="heading mt-2">Time Sheet</p>
          </div> */}
        {/* <div className="div my-3">
            <p
              className="hired-designation"
              // onChange={(e) => setTimeList(e.target.value)}
            >
              February 2021 (6 Days)
            </p>
          </div> */}
        {/* <hr className="line" /> */}

        {/* <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div> */}

        {/* <hr className="line" />

          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div> */}

        {/* <hr className="line" /> */}

        {/* <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button
              className="toggle-btn"
              onClick={() => {
                // setWork(!work);
              }}
            >
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div> */}

        {/* {work ? <WorkDetail /> : null} */}

        {/* <hr className="line" />

          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div> */}

        {/* <hr className="line" />
          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          <hr className="line" /> */}

        {/* <div className="div my-3">
            <p
              className="hired-designation"
              // onChange={(e) => setTimeList(e.target.value)}
            >
              February 2021 (6 Days)
            </p>
          </div> */}
        {/* <hr className="line" /> */}
        {/* 
          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>
          <hr className="line" /> */}

        {/* <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div> */}

        {/* <hr className="line" /> */}
        {/* 
          <div className="space-between d-flex my-2">
            <p className="text"
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div> */}

        {/* <div className="div w-100 sticky-bottom pb-2 bg-white">
            <button
              className="theme-btn w-100 btn-block"
              onClick={(e)=>{
                e.stopPropagation()
                // props?.timesheetPopup(false)
              }
               }
            >
              Done
            </button>
          </div> */}
        {/* </div> */}

      </>




      {/* ---------------------------------TimeSheet---------------------------------- */}

      <>
        {timeSheet?.length != 0 ?
        timeSheet?.map((item, i) => {
          console.log("timesheetitem", item)
          return (
            <div className=' timesheet-col'>
            <div className="text-center bg-white sticky-top mb-5 p-2" key={i} >
              <div className="space-between d-flex my-6" style={{cursor: 'pointer'}} onClick={() => {
                setShowTimeSlot(!showTimeSlot)
                setTimeSlotIndexing(i)

              }}>
                <p className="text mb-3" style={{ fontSize: '20px' }}
                // onChange={(e) => setTimeList(e.target.value)}
                >
                  {moment(item?.date).format('D MMM YYYY')}
                </p>
                <button className="toggle-btn">
                  <img src="./images/toggle-down.png" alt="" />
                </button>
              </div>
              {showTimeSlot && (timeSlotIndexing === i) &&
                <>
                  {item?.data?.map((itemData, index) => {
                    console.log("itemdata", itemData)
                    return (
                      <div style={{ marginBottom: '10px' }} key={index}>
                        <div style={{ textAlign: 'left', fontSize: '14px' }}>
                          <div style={{ display: 'inline-block', fontWeight: 'bold' }}>
                            <span>{itemData?.check_in_time}</span> -  <span>{itemData?.check_out_time}</span>
                           {
                            itemData?.status == "CREATED" ? null : 
                           <span className='mx-2' style={{ color : itemData.status == "DISAPPROVED" ? "red" : "green" }}>  {itemData?.status == "DISAPPROVED" ? lang && Object.keys(lang).length > 0 ? lang[ln]?.Lastest['Status : Rejected']:"" : lang && Object.keys(lang).length > 0 ? lang[ln]?.Lastest['Status : Accepted']:""}  </span>

                           } 
                          </div>
                          { (itemData?.status == "CREATED" )  &&
                            <div style={{ display: 'inline-block' }}>
                              <span> 
                                <img src='../images/checklist_green.png'
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setGreenPopup(true)
                                    setTimesheetId(itemData?.id)
                                    setStatus("APPROVED")
                                  }}
                                  style={{ width: '20px', height: '20px', marginRight: '20px', cursor: 'pointer' }} />
                              </span>

                              <span>
                                <img src='../images/checklist_red.png'
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setRedPopup(true)
                                    setTimesheetId(itemData?.id)
                                    setStatus("DISAPPROVED")
                                  }}
                                  style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
                              </span>
                            </div>
                          }

                        </div>
                        <div style={{
                          display: 'flex', justifyContent: 'space-between', marginTop: '3px',
                          fontSize: '12px', color: 'black'
                        }}>

                          <p style={{ display: "flex", justifyContent: "flex-start" }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation["Task Description"]:""}</p>

                          <span>{itemData?.hours_worked}{lang && Object.keys(lang).length > 0 ? lang[ln]?.HireDetails["Hours"]:""}</span>
                        </div>
                        <span style={{ display: "flex", justifyContent: "flex-start", color: 'grey' }}>{itemData?.task_details}</span>

                      </div>
                    )
                  })}

                </>
              }
              <hr className="line " style={{ marginTop: '20px' }} />






            </div>
            </div>
          )
        }) : <div style={{ width: '100%', height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <h3>{t('No Data Found')}</h3>
      </div>}

      </>
      {(greenPopup) &&
        <div className="blur-screen-full-area inner-modal flex-center" >
          <div className="form-container my-3" style={{ position: 'unset', marginLeft: "20px" ,    width: "auto",display:"block"}}>
            <h6 className='text-center m-3'>{t('Confirm To Accept')}</h6>
            <div className=" flex-center">
            <button
                        className="theme-btn px-5 text-center w-70 mx-2"
                        style={{  }}
              onClick={(e) => {
                ApproveTimesheet()
                Approved()

                e.stopPropagation()
                setGreenPopup(false)
                handleReject()


              }}>{t('OK')}</button>
            <button
       className="theme-btn px-5 text-center w-70 mx-2"

              style={{ }}
              onClick={(e) => {
                e.stopPropagation()
                setGreenPopup(false)


              }}>{t('Not Now')}
            </button>
            </div>
          </div>
        </div>} :
      {(redPopup) &&
        <div className="blur-screen-full-area inner-modal flex-center" >
          <div className="form-container my-4" style={{ position: 'unset', marginLeft: "20px" ,    width: "auto",display:"block"}}>
            <h6 className='text-center m-3'>{t('Confirm To Reject')}</h6>
            <div className=" flex-center">
            <button
              className="theme-btn px-5 text-center w-70 mx-2"
              style={{}}
              onClick={(e) => {
                ApproveTimesheet()
                DisApproved()


                e.stopPropagation()
                setRedPopup(false)
                handleReject()


              }}>{t('OK')}</button>
            <button
           className="theme-btn px-5 text-center w-70 "
              style={{ }}
              onClick={(e) => {
                e.stopPropagation()
                setRedPopup(false)


              }}>{t('Not Now')}
            </button>
            </div>
          </div>
        </div>}

      {(blackScreenPopup) &&
        <div className='blur-screen-full-area flex-center' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', background: 'rgb(0, 0, 0, 0.7' }}>
          <HireBoxBlackScreen item={HiredCandidateData} setBlackPopupValue={setBlackScreenPopup} />
        </div>
      }

    </div>
  )
}

export default HireWithTimeSheet